import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { checkPrivileges } from "../../Helpers";
import Layout from "../../Layout";
import Grid from "@mui/material/Grid";
import instance from "../../axios";
import Table from "../../Components/common/tableWithBackEndPagination";
import Loader from "../../Layout/Loader";
// import ExportImportMenu from "../../Components/Maps/ExportImportMenu";
import CustomDialog from "../../Components/common/Dialog";
import MaintenanceRemindersList from "../Maintenance/MaintenanceRemindersList";
import Tooltip from "../../Components/common/Tooltip";
import PmsPageFilters from "../../Components/common/PmsPageFilters";
import PmsGroupedTable from "../../Components/common/PmsGroupedTable";
import ScheduleBookingModal from "./ScheduleBookingModal";
import CreateTicketForm from "../../Components/CRC/CreateTicketForm";
import { notifyError } from "../../Utils/CustomNotifcations";
import withTranslationWrapper from "../../HOC/withTranslation";
import moment from "moment-timezone";
// import SearchField from "../../Components/common/SearchField";
const CancelToken = axios.CancelToken;
let source = "";

class Invoice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initFetch: false,
      currentPage: 1,
      pagesize: 50,
      showStats: false,
      selectedAreaId: "",
      selectedvehicleId: "",
      to: "",
      from: "",
      loader: false,
      openCreateForm: false,
      itemPagination: {
        items: [],
        total: 0,
        currentPage: 0,
        currentDevice: this.props.deviceId,
        hasNext: true,
        searchText: "",
      },
      showImportedInvoiceError: false,
      importedInvoiceData: {},
      status: "",
      plateNo: "",
      category: "",
      itemCode: "",
      completed: "0",
      wanted: "1",
      selected: "missedOpportunity",
      overDueRangeEnabled: true,
      dueRangeEnabled: true,
      isShowReminder: false,
      expandedGroupKeys: [],
      expandedGroups: {},
      bookingModalOpen: false,
      bookingPrediction: null,
      bookingGroup: null,
      crcModalOpen: false,
      crcInitialValues: null,
    };
  }

  componentWillUnmount() {
    this.setState({
      assignMode: "",
      currentPage: 1,
      pagesize: 50,
      selectedvehicleId: "",
      itemPagination: {
        items: [],
        total: 0,
        currentPage: 0,
        currentDevice: this.props.deviceId,
        hasNext: true,
        searchText: "",
      },
    });
  }

  componentWillMount() {
    if (
      this.props.logInUser &&
      this.props.logInUser.id &&
      this.state.initFetch === false
    ) {
      this.setState(
        {
          initFetch: true,
        },
        () => {
          this.applyDefaultDateRangeForTab(this.state.selected, () =>
            this.fetchData(
              this.props.logInUser,
              this.state.currentPage,
              this.state.pagesize,
            ),
          );
        },
      );
    }
  }

  componentWillReceiveProps(n) {
    if (n.logInUser && n.logInUser.id && this.state.initFetch === false) {
      this.setState(
        {
          initFetch: true,
        },
        () => {
          this.applyDefaultDateRangeForTab(this.state.selected, () =>
            this.fetchData(
              this.props.logInUser,
              this.state.currentPage,
              this.state.pagesize,
            ),
          );
        },
      );
    }
  }

  getAppTimezone = () => {
    if (
      this.props.logInUser &&
      this.props.logInUser.attributes &&
      this.props.logInUser.attributes.timezone
    ) {
      return this.props.logInUser.attributes.timezone;
    }
    if (
      this.props.ServerSetting &&
      this.props.ServerSetting.attributes &&
      this.props.ServerSetting.attributes.timezone
    ) {
      return this.props.ServerSetting.attributes.timezone;
    }
    return "Asia/Riyadh";
  };

  getDefaultDateRangeForTab = (tab) => {
    const timezone = this.getAppTimezone();
    moment.tz.setDefault(timezone);

    if (tab === "missedOpportunity") {
      const toDate = moment().endOf("day").toISOString();
      const fromDate = moment()
        .subtract(30, "days")
        .startOf("day")
        .toISOString();
      return { from: fromDate, to: toDate };
    }

    if (tab === "potentialOpportunity") {
      const fromDate = moment().startOf("day").toISOString();
      const toDate = moment().add(30, "days").endOf("day").toISOString();
      return { from: fromDate, to: toDate };
    }

    return { from: "", to: "" };
  };

  normalizeRangeParamValue = (value) => {
    if (!value) return "";
    if (typeof value !== "string") return value;
    if (value.startsWith("&from=")) return value.replace("&from=", "");
    if (value.startsWith("&to=")) return value.replace("&to=", "");
    return value;
  };

  isDefaultRangeAligned = (tab, fromValue, toValue) => {
    const normalizedFrom = this.normalizeRangeParamValue(fromValue);
    const normalizedTo = this.normalizeRangeParamValue(toValue);
    if (!normalizedFrom || !normalizedTo) return false;
    const expected = this.getDefaultDateRangeForTab(tab);
    const fromDiff = Math.abs(
      new Date(normalizedFrom).getTime() - new Date(expected.from).getTime(),
    );
    const toDiff = Math.abs(
      new Date(normalizedTo).getTime() - new Date(expected.to).getTime(),
    );
    // allow tiny client timing differences
    return fromDiff <= 1000 && toDiff <= 1000;
  };

  applyDefaultDateRangeForTab = (tab, callback) => {
    const shouldApply =
      (tab === "missedOpportunity" && this.state.overDueRangeEnabled) ||
      (tab === "potentialOpportunity" && this.state.dueRangeEnabled);

    if (!shouldApply) {
      this.setState(
        {
          from: "",
          to: "",
        },
        () => callback && callback(),
      );
      return;
    }

    const range = this.getDefaultDateRangeForTab(tab);
    this.setState(
      {
        from: range.from ? `&from=${range.from}` : "",
        to: range.to ? `&to=${range.to}` : "",
      },
      () => callback && callback(),
    );
  };

  fetchMoreItems = (a, b, c) => {
    let pagination = true;
    this.fetchData(
      this.props.logInUser,
      this.state.currentPage,
      this.state.pagesize,
      pagination,
    );
  };

  searchItems = (text) => {
    this.setState(
      {
        searchText: text,
      },
      () => {
        this.fetchData(this.props.logInUser, 1, this.state.pagesize);
      },
    );
  };

  clearExpandedGroups = () => {
    this.setState({
      expandedGroupKeys: [],
      expandedGroups: {},
    });
  };

  getPredictionStatus = () =>
    this.state.selected === "missedOpportunity"
      ? 1
      : this.state.selected === "potentialOpportunity"
        ? 2
        : 0;

  getGroupKey = (group) => {
    const contractNumber =
      group?.contractNumber ||
      group?.cn ||
      this.props.ServerSetting?.contractNumber ||
      "";
    const plateNo = group?.plateNumber || group?.plateNo || "";
    return `${contractNumber}__${plateNo}`;
  };

  buildGroupedPredictionQuery = (page, perPage) => {
    const status = this.getPredictionStatus();
    const contractNumber = this.props.ServerSetting?.contractNumber || "";
    const isOwner = Number(this.props.logInUser?.userType) === -1;
    let url = `/api/predictions/getGrouped?page=${page}&limit=${perPage}&status=${status}`;

    if (isOwner) {
      url += `&all=true`;
    }
    if (contractNumber) {
      url += `&cn=${encodeURIComponent(contractNumber)}`;
    }
    if (this.state.from) url += this.state.from;
    if (this.state.to) url += this.state.to;
    url += this.buildPageFilterQuery();

    return url;
  };

  buildGroupDetailQuery = (group, page, perPage) => {
    const status = this.getPredictionStatus();
    const contractNumber =
      group?.contractNumber ||
      group?.cn ||
      this.props.ServerSetting?.contractNumber ||
      "";
    const plateNo = group?.plateNumber || group?.plateNo || "";
    let url = `/api/predictions/getByContractPlate?page=${page}&limit=${perPage}&status=${status}`;

    if (contractNumber) {
      url += `&cn=${encodeURIComponent(contractNumber)}`;
    }
    if (plateNo) {
      url += `&plateNo=${encodeURIComponent(plateNo)}`;
    }
    if (this.state.from) url += this.state.from;
    if (this.state.to) url += this.state.to;
    // Apply the same page filters (except plateNo, already set from the group)
    const { category, itemCode, completed, wanted } = this.state;
    if (category?.trim()) {
      url += `&category=${encodeURIComponent(category.trim())}`;
    }
    if (itemCode?.trim()) {
      url += `&itemCode=${encodeURIComponent(itemCode.trim())}`;
    }
    if (completed !== "" && completed != null) {
      url += `&completed=${completed}`;
    }
    if (wanted !== "" && wanted != null) {
      url += `&wanted=${wanted}`;
    }

    return url;
  };

  fetchGroupDetails = (group, page = 1) => {
    const groupKey = this.getGroupKey(group);
    const perPage = this.state.pagesize;

    this.setState((prevState) => ({
      expandedGroups: {
        ...prevState.expandedGroups,
        [groupKey]: {
          ...(prevState.expandedGroups[groupKey] || {}),
          loading: true,
        },
      },
    }));

    instance({
      url: this.buildGroupDetailQuery(group, page, perPage),
      method: "GET",
      cancelToken: source.token,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        const lastPage =
          Math.ceil((res.total || 0) / (res.pageSize || perPage)) || 1;
        this.setState((prevState) => ({
          expandedGroups: {
            ...prevState.expandedGroups,
            [groupKey]: {
              items: res.data || [],
              page: res.page || page,
              pageSize: res.pageSize || perPage,
              total: res.total || 0,
              hasNext: res.hasNext,
              lastPage,
              loading: false,
            },
          },
        }));
      })
      .catch(() => {
        this.setState((prevState) => ({
          expandedGroups: {
            ...prevState.expandedGroups,
            [groupKey]: {
              ...(prevState.expandedGroups[groupKey] || {}),
              loading: false,
              items: [],
            },
          },
        }));
      });
  };

  toggleGroupExpand = (group) => {
    const groupKey = this.getGroupKey(group);
    const isOpen = this.state.expandedGroupKeys.includes(groupKey);

    if (isOpen) {
      this.setState({
        expandedGroupKeys: this.state.expandedGroupKeys.filter(
          (key) => key !== groupKey,
        ),
      });
      return;
    }

    this.setState(
      {
        expandedGroupKeys: [...this.state.expandedGroupKeys, groupKey],
      },
      () => {
        const groupState = this.state.expandedGroups[groupKey];
        if (!groupState?.items?.length) {
          this.fetchGroupDetails(group, 1);
        }
      },
    );
  };

  handleGroupPageChange = (group, action) => {
    const groupKey = this.getGroupKey(group);
    const groupState = this.state.expandedGroups[groupKey] || {};
    const currentPage = groupState.page || 1;
    const lastPage = groupState.lastPage || 1;
    let nextPage = currentPage;

    if (action === "first") nextPage = 1;
    else if (action === "prev") nextPage = Math.max(1, currentPage - 1);
    else if (action === "next") nextPage = currentPage + 1;
    else if (action === "last") nextPage = lastPage;

    if (nextPage !== currentPage) {
      this.fetchGroupDetails(group, nextPage);
    }
  };

  openBookingModal = (prediction, group) => {
    this.setState({
      bookingModalOpen: true,
      bookingPrediction: prediction,
      bookingGroup: group,
    });
  };

  closeBookingModal = () => {
    this.setState({
      bookingModalOpen: false,
      bookingPrediction: null,
      bookingGroup: null,
    });
  };

  openCrcModal = (prediction) => {
    const itemCode = prediction?.itemCode || "";
    const requestText = `Request for ${itemCode}`.trim();
    this.setState({
      crcModalOpen: true,
      crcInitialValues: {
        name: requestText,
        description: requestText,
        ticketType: "support",
        department: "Technical Support",
      },
    });
  };

  closeCrcModal = () => {
    this.setState({
      crcModalOpen: false,
      crcInitialValues: null,
    });
  };

  handlePageFilterChange = (name, value) => {
    this.setState({ [name]: value });
  };

  applyPageFilters = () => {
    this.clearExpandedGroups();
    this.setState({ currentPage: 1, loader: true }, () => {
      this.fetchData(this.props.logInUser, 1, this.state.pagesize, false, true);
    });
  };

  clearPageFilters = () => {
    this.clearExpandedGroups();
    this.setState(
      {
        plateNo: "",
        category: "",
        itemCode: "",
        completed: "0",
        wanted: "1",
        currentPage: 1,
        loader: true,
      },
      () => {
        this.applyDefaultDateRangeForTab(this.state.selected, () =>
          this.fetchData(
            this.props.logInUser,
            1,
            this.state.pagesize,
            false,
            true,
          ),
        );
      },
    );
  };

  buildPageFilterQuery = () => {
    const { plateNo, category, itemCode, completed, wanted } = this.state;
    let query = "";
    if (plateNo?.trim()) {
      query += `&plateNo=${encodeURIComponent(plateNo.trim())}`;
    }
    if (category?.trim()) {
      query += `&category=${encodeURIComponent(category.trim())}`;
    }
    if (itemCode?.trim()) {
      query += `&itemCode=${encodeURIComponent(itemCode.trim())}`;
    }
    if (completed !== "" && completed != null) {
      query += `&completed=${completed}`;
    }
    if (wanted !== "" && wanted != null) {
      query += `&wanted=${wanted}`;
    }
    return query;
  };

  submitSideBarSearch = (data, type) => {
    this.clearExpandedGroups();
    const selectedTab = this.state.selected;
    const updates = {};
    if (
      selectedTab === "missedOpportunity" &&
      this.state.overDueRangeEnabled &&
      !this.isDefaultRangeAligned(selectedTab, data?.from, data?.to)
    ) {
      updates.overDueRangeEnabled = false;
    }
    if (
      selectedTab === "potentialOpportunity" &&
      this.state.dueRangeEnabled &&
      !this.isDefaultRangeAligned(selectedTab, data?.from, data?.to)
    ) {
      updates.dueRangeEnabled = false;
    }

    this.setState(
      {
        ...updates,
        loader: true,
        to: data.to ? `&to=${data.to}` : "",
        from: data.from ? `&from=${data.from}` : "",
        status: `${data.status}`,
        selectedAreaId: data.selectedAreaId,
        selectedvehicleId: data.selectedvehicleId,
      },
      () => {
        if (type === "downloadExcel") {
          this.downloadCreditDebit();
        } else {
          this.fetchData(
            this.props.logInUser,
            this.state.currentPage,
            this.state.pagesize,
          );
        }
      },
    );
  };

  downloadCreditDebit = (type) => {
    let accept;
    let dateto = this.state.to || "";
    let datefrom = this.state.from || "";
    let userId = this.state.selectedUser || "";

    if (type === "downloadPdf") {
      accept = "application/pdf";
    } else {
      accept =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    }
    let header;
    header = {
      headers: new Headers({
        "Content-Type": "application/json",
        Accept: accept,
      }),
      method: "GET",
    };

    let status =
      this.state.selected === "missedOpportunity"
        ? 1
        : this.state.selected === "potentialOpportunity"
          ? 2
          : 0;

    let apiUrl;
    apiUrl = `/api/predictions/export?status=${status}&contractNumber=${this.props.ServerSetting.contractNumber}`;

    if (dateto) apiUrl += `${dateto}`;
    if (datefrom) apiUrl += `${datefrom}`;

    try {
      fetch(apiUrl, { ...header })
        .then((response1) => {
          if (response1.status === 200) {
            if (type === "downloadPdf") {
              response1.blob().then((response) => {
                this.setState(
                  {
                    selectedAreaId: "",
                    selectedvehicleId: "",
                    to: "",
                    from: "",
                    loader: false,
                  },
                  () => {
                    this.saveData(response, "CreditDebit.pdf");
                  },
                );
              });
            } else {
              response1.blob().then((response) => {
                this.setState(
                  {
                    selectedAreaId: "",
                    selectedvehicleId: "",
                    to: "",
                    from: "",
                    loader: false,
                  },
                  () => {
                    this.saveData(response, "Missed_Opportunity.xlsx");
                  },
                );
              });
            }
          } else {
            this.setState({ loader: false });
            this.props.dispatch(
              notifyError("Download failed with status:" + response1?.status),
            );
          }
        })
        .catch((error) => {
          this.setState({ loader: false });
        });
    } catch (error) {
      console.error("Error", error);
    }
  };

  saveData = (blob, filename) => {
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      const a = document.createElement("a");
      document.body.appendChild(a);
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = filename;
      a.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }, 0);
    }
  };

  handleChangeTabs = (e) => {
    if (e === "predictive") {
      this.setState({
        isShowReminder: !this.state.isShowReminder,
        selected: e,
      });
      return;
    } else {
      this.setState({
        isShowReminder: false,
      });
    }
    this.clearExpandedGroups();
    const tabResetState = { selected: e };
    if (e === "missedOpportunity") {
      tabResetState.overDueRangeEnabled = true;
    }
    if (e === "potentialOpportunity") {
      tabResetState.dueRangeEnabled = true;
    }
    this.setState(tabResetState, () => {
      this.applyDefaultDateRangeForTab(e, () => {
        this.fetchData(this.props.logInUser, 1, this.state.pagesize);
      });
    });
  };

  handleToggleOverDueRange = (checked) => {
    this.setState({ overDueRangeEnabled: checked }, () => {
      if (this.state.selected !== "missedOpportunity") return;
      this.applyDefaultDateRangeForTab("missedOpportunity", () => {
        this.clearExpandedGroups();
        this.fetchData(
          this.props.logInUser,
          1,
          this.state.pagesize,
          false,
          true,
        );
      });
    });
  };

  handleToggleDueRange = (checked) => {
    this.setState({ dueRangeEnabled: checked }, () => {
      if (this.state.selected !== "potentialOpportunity") return;
      this.applyDefaultDateRangeForTab("potentialOpportunity", () => {
        this.clearExpandedGroups();
        this.fetchData(
          this.props.logInUser,
          1,
          this.state.pagesize,
          false,
          true,
        );
      });
    });
  };

  fetchData = (logInUser, page, perPage, pagi, reset) => {
    source = CancelToken.source();
    let url = "";
    let searchText = this.state.searchText;
    if (searchText) {
      searchText = "&search=" + searchText;
    } else {
      searchText = "";
    }

    let items = this.state.itemPagination.items;
    if (reset) {
      items = [];
      this.clearExpandedGroups();
    }

    let dateto = this.state.to || "";
    let datefrom = this.state.from || "";
    const { category, itemCode, plateNo, completed, wanted } = this.state;

    // ── PME tab: call the new endpoint ──────────────────────────────────────
    if (this.state.selected === "pme") {
      url = `/api/maintenance/get/pme?page=${page}&limit=${perPage}&maintenanceId=&plateNo=${plateNo || ""}&vehicleId=`;
      if (dateto) url += `${dateto}`;
      if (datefrom) url += `${datefrom}`;
      if (category) url += `&type=${encodeURIComponent(category)}`;
      if (itemCode) url += `&subType=${encodeURIComponent(itemCode)}`;
      if (completed !== "" && completed != null) {
        url += `&completed=${completed}`;
      }
      if (wanted !== "" && wanted != null) {
        url += `&wanted=${wanted}`;
      }

      instance({
        url,
        method: "GET",
        cancelToken: source.token,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          this.setState({
            loader: false,
            invoices: pagi ? items.concat(res.data) : res.data,
            isDataRecieved: true,
            itemPagination: {
              ...res,
              items: pagi ? items.concat(res.data) : res.data,
            },
            currentPage: res.hasNext ? res.page : 1,
          });
        })
        .catch((error) => {
          // errorHandler(error, this.props.dispatch)
        });
      return;
    }
    // ────────────────────────────────────────────────────────────────────────

    if (
      this.state.selected === "missedOpportunity" ||
      this.state.selected === "potentialOpportunity"
    ) {
      url = this.buildGroupedPredictionQuery(page, perPage);

      instance({
        url,
        method: "GET",
        cancelToken: source.token,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          this.setState({
            loader: false,
            invoices: pagi ? items.concat(res.data) : res.data,
            isDataRecieved: true,
            itemPagination: {
              ...res,
              items: pagi ? items.concat(res.data) : res.data,
            },
            currentPage: res.hasNext ? res.page : 1,
          });
        })
        .catch((error) => {
          // errorHandler(error, this.props.dispatch)
        });
      return;
    }
  };

  setPagination = (user) => {
    const { itemPagination } = this.state;
    if (itemPagination && itemPagination.items && itemPagination.items.length) {
      let nUser = { ...user };
      let lastPage = nUser.total / this.state.pagesize;
      let IsFloate = this.checkFloteNumber(lastPage);
      delete nUser.data;
      nUser.pageSize = this.state.pagesize;
      nUser.lastPage = IsFloate ? parseInt(lastPage + 1) : lastPage;
      return nUser;
    }
    return {};
  };

  handleChangeRowsPerPage = (value, mode) => {
    if (source) {
      source.cancel();
    }
    if (mode === "deliverynotes") {
      this.clearExpandedGroups();
      this.setState(
        {
          pagesize: value,
          currentPage: 1,
        },
        () => {
          this.fetchData(
            this.props.logInUser,
            this.state.currentPage,
            this.state.pagesize,
          );
        },
      );
    }
  };

  handleChangePage = (value, mode) => {
    if (source) {
      source.cancel();
    }
    if (mode === "deliverynotes") {
      this.clearExpandedGroups();
      this.setState(
        {
          currentPage: value,
        },
        () => {
          this.fetchData(
            this.props.logInUser,
            this.state.currentPage,
            this.state.pagesize,
          );
        },
      );
    }
  };

  SearchItem = (searchValue, mode) => {
    if (source) {
      source.cancel();
    }
    this.setState(
      {
        itemSearch: searchValue,
        currentPage: 1,
      },
      () => {
        if (mode === "deliverynotes") {
          this.fetchData(
            this.props.logInUser,
            this.state.currentPage,
            this.state.pagesize,
          );
        }
      },
    );
  };

  checkFloteNumber(n) {
    return Number(n) === n && n % 1 !== 0;
  }

  toggleFilterForm = () => {
    this.setState({
      showStats: !this.state.showStats,
    });
  };

  openImportTable = (item) => {
    this.setState({
      showImportedInvoiceError: true,
      importedInvoiceData: item,
    });
  };

  onCloseImportedModal = () => {
    this.setState({ showImportedInvoiceError: false });
  };

  showReminders = () => {
    this.setState({
      isShowReminder: !this.state.isShowReminder,
    });
  };

  // Row definition for the PME tab
  getPmeRowDefinition = () => [
    {
      id: "plateNo",
      label: this.props.translate("plateNumber"),
    },
    {
      id: "typeName",
      label: this.props.translate("categoryName"),
    },
    {
      id: "subTypeName",
      label: this.props.translate("itemCode"),
    },
    {
      id: "payloadOdo",
      label: this.props.translate("pmeType"),
    },
    {
      id: "payloadTriggerTime",
      label: this.props.translate("target"),
    },
    {
      id: "completed",
      label: this.props.translate("status"),
    },
  ];

  // Row definition for the existing tabs
  getDefaultRowDefinition = () => [
    {
      id: "contractNumber",
      label: this.props.translate("contractNumber"),
    },
    {
      id: "plateNumber",
      label: this.props.translate("plateNumber"),
    },
    {
      id: "categoryName",
      label: this.props.translate("categoryName"),
    },
    {
      id: "itemCode",
      numeric: false,
      disablePadding: false,
      label: this.props.translate("itemCode"),
    },
    {
      id: "lastServiceDate",
      label: this.props.translate("serviceDate"),
    },
    {
      id: "nextExecutionDate",
      label: this.props.translate("nextExecutionDate"),
    },
    {
      id: "nextOdometerReading",
      label: this.props.translate("nextOdometerReading"),
    },
    {
      id: "completed",
      label: this.props.translate("status"),
    },
  ];

  getGroupedChildRowDefinition = () => {
    const { translate } = this.props;

    return [
      {
        id: "categoryName",
        label: translate("type"),
      },
      {
        id: "itemCode",
        label: translate("category"),
      },
      {
        id: "lastServiceDate",
        label: translate("serviceDate"),
      },
      {
        id: "nextExecutionDate",
        label: translate("nextExecutionDate"),
      },
      {
        id: "odometerReading",
        label: translate("serviceOdometer"),
      },
      {
        id: "nextOdometerReading",
        label: translate("nextOdometerReading"),
      },
      {
        id: "businessPotential",
        label: translate("businessPotential"),
      },

      {
        id: "completedAt",
        label: translate("completedAt"),
      },
      {
        id: "completedAtOdo",
        label: translate("completedAtOdo"),
      },
            {
        id: "completed",
        label: translate("status"),
      },
    ];
  };

  handleGroupedTablePageChange = (action) => {
    const pagination = this.setPagination(this.state.itemPagination);
    const currentPage = pagination.page || 1;
    const lastPage = pagination.lastPage || 1;
    let nextPage = currentPage;

    if (action === "first") nextPage = 1;
    else if (action === "prev") nextPage = Math.max(1, currentPage - 1);
    else if (action === "next") nextPage = currentPage + 1;
    else if (action === "last") nextPage = lastPage;

    if (nextPage !== currentPage) {
      this.handleChangePage(nextPage, "deliverynotes");
    }
  };

  render() {
    const { selected } = this.state;

    const tabStyle = (tabKey) => ({
      flex: 1,
      borderRadius: "6px 6px 0 0",
      fontSize: "inherit",
      textDecoration: "none",
      cursor: "pointer",
      fontWeight: "bold",
      textAlign: "center",
      color: "#ffffff",
      padding: "8px 4px",
      background:
        selected === tabKey
          ? this.props.themecolors.menuActiveBackground
          : this.props.themecolors.themeDarkColor,
      borderBottom:
        selected === tabKey
          ? `3px solid ${this.props.themecolors.menuActiveBackground}`
          : "3px solid transparent",
    });

    const endMessage =
      this.state.itemPagination && this.state.itemPagination.total > 0 ? (
        <p style={{ textAlign: "center", color: "#ccc" }}>
          -- {this.props.translate("end")} --
        </p>
      ) : (
        <p style={{ textAlign: "center", color: "#ccc" }}>
          {this.props.translate("notFound")}
        </p>
      );

    return (
      <div>
        <Layout
          {...this.props}
          endMessage={endMessage}
          searchItems={this.searchItems}
          fetchMoreItems={this.fetchMoreItems}
          modeEmpty={this.modeEmpty}
          toggleFilterForm={this.toggleFilterForm}
          submitSideBarSearch={this.submitSideBarSearch}
          downloadInvoice={this.downloadInvoice}
          isShowReminder={this.state.isShowReminder}
          {...this.state}
        >
          <div className="main-content-page">
            <div
              style={{
                background: this.props.themecolors.backgroundColor,
                color: this.props.themecolors.textColor,
                borderRadius: 6,
                paddingTop: 5,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{ display: "flex", width: "80%", marginTop: "0.5rem" }}
                >
                  {/* ── Tab 1: Overdue Vehicle Services ── */}
                  <span
                    style={tabStyle("missedOpportunity")}
                    onClick={() => this.handleChangeTabs("missedOpportunity")}
                  >
                    {this.props.translate("AI PMS Due")}
                  </span>

                  {/* ── Tab 2: Vehicles Due for Services ── */}
                  <span
                    style={tabStyle("potentialOpportunity")}
                    onClick={() =>
                      this.handleChangeTabs("potentialOpportunity")
                    }
                  >
                    {this.props.translate("AI PMS Schedule")}
                  </span>

                  {/* ── Tab 3: Custom Predictive Maint. Engine ── */}
                  {checkPrivileges("maintenance") && (
                    <>
                      <Tooltip
                        title={this.props.translate(
                          "Create Personal Predictive Maint.",
                        )}
                        classes={{
                          popper: "menu-popper",
                          tooltip: "menu-popper-tooltip",
                        }}
                      >
                        <span
                          style={tabStyle("predictive")}
                          onClick={() => this.handleChangeTabs("predictive")}
                        >
                          {this.props.translate(
                            "Custom Predictive Maint. Engine",
                          )}
                        </span>
                      </Tooltip>

                      {/* ── Tab 4: PME (new) ── */}
                      <span
                        style={tabStyle("pme")}
                        onClick={() => this.handleChangeTabs("pme")}
                      >
                        {this.props.translate("PME")}
                      </span>
                    </>
                  )}
                </div>
              </div>
              {["missedOpportunity", "potentialOpportunity", "pme"].includes(
                selected,
              ) &&
                !this.state.isShowReminder && (
                  <>
                    <PmsPageFilters
                      showWantedFilter
                      selectedTab={selected}
                      values={{
                        plateNo: this.state.plateNo,
                        category: this.state.category,
                        itemCode: this.state.itemCode,
                        completed: this.state.completed,
                        wanted: this.state.wanted,
                      }}
                      onChange={this.handlePageFilterChange}
                      onSubmit={this.applyPageFilters}
                      onClear={this.clearPageFilters}
                      overDueRangeEnabled={this.state.overDueRangeEnabled}
                      dueRangeEnabled={this.state.dueRangeEnabled}
                      onToggleOverDueRange={this.handleToggleOverDueRange}
                      onToggleDueRange={this.handleToggleDueRange}
                      translate={this.props.translate}
                    />
                  </>
                )}

              {
                <Grid container style={{ height: "100%" }}>
                  {this.state.isShowReminder || selected === "predictive" ? (
                    <Grid item sm={12} xs={12}>
                      <MaintenanceRemindersList
                        showReminders={this.showReminders}
                        translate={this.props.translate}
                        themecolors={this.props.themecolors}
                        ServerSetting={this.props.ServerSetting}
                        classes={this.props.classes}
                        selectedTab={selected}
                        {...this.props}
                      />
                    </Grid>
                  ) : (
                    <Grid item sm={12} xs={12}>
                      {this.state.isDataRecieved ? (
                        ["missedOpportunity", "potentialOpportunity"].includes(
                          selected,
                        ) ? (
                          <>
                            <PmsGroupedTable
                              rows={
                                (this.state.itemPagination &&
                                  this.state.itemPagination.items) ||
                                []
                              }
                              childRowDefinition={this.getGroupedChildRowDefinition()}
                              translate={this.props.translate}
                              pagination={this.setPagination(
                                this.state.itemPagination &&
                                  this.state.itemPagination,
                              )}
                              expandedGroupKeys={this.state.expandedGroupKeys}
                              expandedGroups={this.state.expandedGroups}
                              onToggleGroup={this.toggleGroupExpand}
                              onGroupPageChange={this.handleGroupPageChange}
                              onPageChange={this.handleGroupedTablePageChange}
                              onRowsPerPageChange={(value) =>
                                this.handleChangeRowsPerPage(
                                  value,
                                  "deliverynotes",
                                )
                              }
                              onAddBooking={this.openBookingModal}
                              onCreateCrc={this.openCrcModal}
                            />
                            {this.state.bookingModalOpen ? (
                              <ScheduleBookingModal
                                prediction={this.state.bookingPrediction}
                                group={this.state.bookingGroup}
                                onClose={this.closeBookingModal}
                                onSuccess={this.closeBookingModal}
                                translate={this.props.translate}
                                themecolors={this.props.themecolors}
                                logInUser={this.props.logInUser}
                                ServerSetting={this.props.ServerSetting}
                                vehicles={this.props.vehicles}
                                dispatch={this.props.dispatch}
                              />
                            ) : null}
                            {this.state.crcModalOpen ? (
                              <CustomDialog
                                title={
                                  this.props.translate("createCrc") ||
                                  "Create CRC"
                                }
                                disableCloseBtn
                                onClose={this.closeCrcModal}
                                maxWidth="lg"
                                fullWidth
                                cancelText={
                                  this.props.translate("sharedCancel") ||
                                  "Cancel"
                                }
                              >
                                <div style={{ padding: 16 }}>
                                  <CreateTicketForm
                                    translate={this.props.translate}
                                    handleAddCloseForm={this.closeCrcModal}
                                    initialValues={this.state.crcInitialValues}
                                  />
                                </div>
                              </CustomDialog>
                            ) : null}
                          </>
                        ) : (
                          <>
                            <Table
                              rows={
                                (this.state.itemPagination &&
                                  this.state.itemPagination.items) ||
                                []
                              }
                              pagination={this.setPagination(
                                this.state.itemPagination &&
                                  this.state.itemPagination,
                              )}
                              handleChangeRowsPerPage={(n) =>
                                this.handleChangeRowsPerPage(n, "deliverynotes")
                              }
                              handleChangePage={(n) =>
                                this.handleChangePage(n, "deliverynotes")
                              }
                              logInUser={this.props.logInUser}
                              themecolors={this.props.themecolors}
                              translate={this.props.translate}
                              vehicles={this.props?.vehicles || []}
                              invoiceModule
                              ServerSetting={this.props.ServerSetting}
                              rowDefinition={
                                selected === "pme"
                                  ? this.getPmeRowDefinition()
                                  : this.getDefaultRowDefinition()
                              }
                            />
                          </>
                        )
                      ) : (
                        <Loader />
                      )}
                    </Grid>
                  )}
                </Grid>
              }
            </div>
          </div>

          {this.state.showImportedInvoiceError && (
            <CustomDialog
              title="Imported Delivery Notes"
              visable={true}
              onClose={this.onCloseImportedModal}
              bodyPadding={10}
              hideDragIcon
              fullWidth
              isVisableBtn
              noFullScreen
            >
              <div>
                <table>
                  <tr
                    style={{
                      borderBottom: "1px solid black",
                    }}
                  >
                    <td>
                      <strong>Delivery Note no</strong>
                    </td>
                    <td>
                      <strong>Error</strong>
                    </td>
                  </tr>
                  {Object.entries(this.state.importedInvoiceData).map(
                    (item, i) => {
                      return (
                        <tr
                          key={i}
                          style={{
                            borderBottom: "1px solid black",
                            paddingTop: 2,
                          }}
                        >
                          <td style={{ padding: 10 }}>
                            <strong>{item[0]}</strong>
                          </td>
                          <td style={{ padding: 10 }}>{item[1]}</td>
                        </tr>
                      );
                    },
                  )}
                </table>
              </div>
            </CustomDialog>
          )}
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  themecolors: state.themeColors,
  logInUser: state.logInUsers,
  ServerSetting: state.ServerSetting,
  vehicles: state.vehicles,
});

export default connect(mapStateToProps)(withTranslationWrapper(Invoice));
